import { render, staticRenderFns } from "./WvSteakHouseWineListSection.vue?vue&type=template&id=4edda456&scoped=true"
import script from "./WvSteakHouseWineListSection.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseWineListSection.vue?vue&type=script&lang=ts"
import style0 from "./WvSteakHouseWineListSection.vue?vue&type=style&index=0&id=4edda456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edda456",
  null
  
)

export default component.exports